var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_4700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2871 10.225C20.2871 9.56668 20.2288 8.94168 20.1288 8.33334H10.7121V12.0917H16.1038C15.8621 13.325 15.1538 14.3667 14.1038 15.075V17.575H17.3204C19.2038 15.8333 20.2871 13.2667 20.2871 10.225Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7121 19.9992C13.4121 19.9992 15.6704 19.0992 17.3204 17.5742L14.1038 15.0742C13.2038 15.6742 12.0621 16.0409 10.7121 16.0409C8.10378 16.0409 5.89544 14.2826 5.10378 11.9076H1.78711V14.4826C3.42878 17.7492 6.80378 19.9992 10.7121 19.9992Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10376 11.906C4.89543 11.306 4.7871 10.6643 4.7871 9.99764C4.7871 9.33098 4.90376 8.68931 5.10376 8.08931V5.51431H1.7871C1.10376 6.86431 0.712097 8.38098 0.712097 9.99764C0.712097 11.6143 1.10376 13.131 1.7871 14.481L5.10376 11.906Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7121 3.95833C12.1871 3.95833 13.5038 4.46667 14.5454 5.45834L17.3954 2.60833C15.6704 0.991668 13.4121 0 10.7121 0C6.80378 0 3.42878 2.25 1.78711 5.51667L5.10378 8.09167C5.89544 5.71667 8.10378 3.95833 10.7121 3.95833Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_4700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.3777107b0afe4daaa73f1a3e45107811.svg";
export { ForwardRef as ReactComponent };